export const commonMixin = {
  props: {
    rules: {
      default: () => [],
    },
  },
};
